import styled, { css } from "styled-components";
import {
  marginHelpers,
  paddingHelpers,
  flexHelpers,
} from "../../styles/positioning";
import ie9andAboveOnly from "../../styles/ieSupport";
import boxShadow from "../../styles/boxShadow";
import getCssArrow from "../../styles/arrow";
import media from "../../styles/media";

export const Size = {
  Small: "small",
  Medium: "medium",
  Large: "large",
};

export const BackgroundColour = {
  Primary: "primary",
  Secondary: "secondary",
};
const Card = styled.div`
  ${paddingHelpers} ${marginHelpers} ${flexHelpers}
  padding: ${({ theme }) => `calc(${theme.padding.base} * 2)`};
  border-radius: calc(${({ theme }) => theme.border.radius} * 2);

  img {
    max-width: calc(100% + ${({ theme }) => theme.padding.base} * 4);
    margin-left: ${({ theme }) => `calc(-${theme.padding.base} * 2)`};
    margin-bottom: ${({ theme }) => theme.padding.base};

    &:first-child {
      margin-top: ${({ theme }) => `calc(-${theme.padding.base} * 2)`};
      border-top-right-radius: ${({ theme }) => theme.border.radius};
      border-top-left-radius: ${({ theme }) => theme.border.radius};
    }
  }

  img + button,
  img + a,
  img + span a {
    margin-top: calc(-${({ theme }) => theme.padding.base} * 3);
  }

  ${ie9andAboveOnly`
    img {
      margin-left: 0;
    }

    img + span {
      z-index: 0;
    }
  `} & > h3,
    & > h4,
    & > h5,
    & > h6,
    & > a,
    & > button,
    & > span,
    & > div,
    & > p {
    width: 100%;
    margin-bottom: ${({ theme }) => theme.padding.base};
  }

  & > hr {
    margin-bottom: calc(${({ theme }) => theme.padding.base}*2);
  }

  & > h2 ~ p {
    margin-bottom: calc(${({ theme }) => theme.padding.base} / 2);
  }
  & > p ~ p {
    margin-bottom: calc(${({ theme }) => theme.padding.base} / 2);
  }

  & > *:last-child {
    margin-bottom: 0;
  }

  ${({ primary, secondary, danger, simple, theme }) => {
    switch (true) {
      case primary:
        return css`
          background-color: ${theme.colors.primary.lighter};
          border: 2px solid ${theme.colors.primary.dark};
        `;
      case secondary:
        return css`
          border: 2px solid ${theme.colors.primary.dark};
        `;
      case danger:
        return css`
          background-color: ${theme.colors.error.light};
          border: 2px solid ${theme.colors.error.dark};
        `;
      case simple:
        return css``;
      default:
        return css`
          background-color: ${theme.colors.greys.white};
          ${boxShadow};
        `;
    }
  }};

  ${({
    theme: { border, colors, font, padding },
    header,
    backgroundColour,
    size,
  }) =>
    header
      ? css`
          h6:first-child {
            background-color: ${() => {
              switch (backgroundColour) {
                case BackgroundColour.Primary:
                  return colors.tertiary.default;
                case BackgroundColour.Secondary:
                  return colors.secondary.default;
                default:
                  return colors.tertiary.default;
              }
            }};
            color: ${colors.greys.white};
            margin-top: calc(${padding.base} * -2);
            ${() => {
              if (size === Size.Large) {
                return `width: calc(100% + ${padding.base} * 8);
                margin-top: calc(${padding.base} * -4);`;
              }
              return `width: calc(100% + ${padding.base} * 4);`;
            }}
            border-top-left-radius: calc(${border.radius} * 2);
            border-top-right-radius: calc(${border.radius} * 2);
            font-weight: ${font.bold};
            text-transform: uppercase;
            padding: ${padding.base} 0;
            line-height: normal;
          }
        `
      : ""} ${({ theme: { padding, font }, size }) => {
    if (size === Size.Medium) {
      return css`
        ${media.md`
        max-width: calc(${font.typographyBreakpoint} +
        ${padding.base} * 2 * 2);`} width: 100%;
      `;
    }
    if (size === Size.Large) {
      return css`
        width: 100%;
        max-width: 420px;
        padding: calc(${padding.base} * 4);
      `;
    }
    return css`
      width: 300px;
    `;
  }} ${({ arrow, primary, secondary }) =>
    arrow
      ? getCssArrow(arrow, {
          primaryBorder: primary || secondary,
          primaryBackground: primary,
        })
      : ""};
`;

Card.displayName = "Card";

// eslint-disable-next-line
export default Card;
